import { render } from "./adminfore.vue?vue&type=template&id=d7169d08&scoped=true"
import script from "./adminfore.vue?vue&type=script&lang=js"
export * from "./adminfore.vue?vue&type=script&lang=js"

import "./adminfore.vue?vue&type=style&index=0&id=d7169d08&lang=less&scoped=true"

import exportComponent from "D:\\HbSave\\roc_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7169d08"]])

export default __exports__